import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

// Branded prism loader shown on first load (once per browser session).
export const PrismLoader = () => {
  const [done, setDone] = useState(
    () =>
      typeof window !== "undefined" &&
      !!sessionStorage.getItem("axor_loaded"),
  );

  useEffect(() => {
    if (done) return;

    document.body.style.overflow = "hidden";

    const t = setTimeout(() => {
      sessionStorage.setItem("axor_loaded", "1");
      setDone(true);
    }, 2200);

    return () => {
      clearTimeout(t);
      document.body.style.overflow = "";
    };
  }, [done]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-axor-hero"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, y: -30 }}
          transition={{
            duration: 0.7,
            ease: [0.16, 1, 0.3, 1],
          }}
          data-testid="prism-loader"
        >
          <div className="light-rays absolute inset-0" />

          {/* ambient glow */}
          <motion.div
            className="absolute h-64 w-64 rounded-full bg-axor-cyan/20 blur-[100px]"
            animate={{
              scale: [0.8, 1.15, 0.8],
              opacity: [0.4, 0.8, 0.4],
            }}
            transition={{
              duration: 2.2,
              ease: "easeInOut",
            }}
          />

          {/* New AXOR Logo */}
          <motion.img
            src="/logo/IMG_4999-removebg-preview.png"
            alt="AXOR Technologies"
            className="relative h-28 w-28 object-contain"
            initial={{
              opacity: 0,
              scale: 0.6,
              rotate: -8,
            }}
            animate={{
              opacity: 1,
              scale: 1,
              rotate: 0,
            }}
            transition={{
              duration: 1,
              ease: [0.16, 1, 0.3, 1],
            }}
          />

          <motion.div
            className="relative mt-8 flex flex-col items-center"
            initial={{
              opacity: 0,
              y: 12,
            }}
            animate={{
              opacity: 1,
              y: 0,
            }}
            transition={{
              delay: 1.2,
              duration: 0.6,
            }}
          >
            <span className="text-lg font-extrabold tracking-[0.4em] text-axor-white">
              AXOR
            </span>

            <span className="mt-1 text-[10px] font-semibold uppercase tracking-[0.34em] text-axor-aqua">
              Technologies
            </span>
          </motion.div>

          {/* progress bar */}
          <div className="relative mt-8 h-px w-40 overflow-hidden rounded-full bg-white/10">
            <motion.div
              className="h-full bg-gradient-to-r from-axor-cyan to-axor-turquoise"
              initial={{ width: "0%" }}
              animate={{ width: "100%" }}
              transition={{
                duration: 2,
                ease: "easeInOut",
              }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
